import { useCallback, useContext } from "react";
import { type RecordSourceSelectorProxy } from "relay-runtime";
import { TreeSelectionContext } from "../TreeSelectionContext";

export const useDraftStatusUpdater = () => {
	const { treeId } = useContext(TreeSelectionContext);
	return useCallback(
		(store: RecordSourceSelectorProxy) => {
			const root = store.get(treeId);
			if (root) root.setValue("Draft", "status");
		},
		[treeId],
	);
};
